import { EnvironmentFilled } from "@ant-design/icons";
import { CheckboxOptionType, RadioChangeEvent } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomRadioButton from "../../../../components/CustomRadioButton";
import { useCoachesContext } from "../../context/CoachesContext";
import styles from "./styleModule";
import "./styles.scss";

const RESORT_CODES = [
  "RSTU_JS",
  "TOMAMU",
  "TEINE",
  "OTARU_ONZE",
  "SAPP_INTL",
  "YZNK",
];

const ResortFilter = () => {
  const { t } = useTranslation();
  const { selectedResort, setSelectedResort } = useCoachesContext();
  const [options, setOptions] = useState<
    (string | number | CheckboxOptionType<any>)[]
  >([]);

  const onChange = (e: RadioChangeEvent) => {
    setSelectedResort(e.target.value);
  };

  useEffect(() => {
    setOptions(
      RESORT_CODES.map((code: string) => {
        return {
          label: t(`skiresort.tab.${code}`),
          value: code,
          icon: (
            <EnvironmentFilled
              style={{ color: "var(--chips-text-inactive)" }}
            />
          ),
        };
      })
    );
  }, []);

  return (
    <CustomRadioButton
      wrapperStyle={styles.radioWrapper}
      items={options}
      onValueChange={onChange}
      selectedValue={selectedResort}
      loading={false}
      centered={true}
    />
  );
};

export default ResortFilter;
